export default {
  title: 'Antalya İli Gayrimenkul Piyasası İstatistikleri',
  tabs: {
    sales: 'Gayrimenkul Satışları',
    permits: 'İnşaat Ruhsatları'
  }
}
